import React from 'react';
import { Button } from '@redpanda/ui';

interface MultiBulkActionButtonProps {
  selectedCount: number;
  onDelete: () => void;
  isDeleting?: boolean;
}

const MultiBulkActionButton: React.FC<MultiBulkActionButtonProps> = ({
  selectedCount,
  onDelete,
  isDeleting = false,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center space-x-3">
      <span className="text-sm text-gray-700 dark:text-white font-medium">
        已選擇 {selectedCount} 項
      </span>

      <Button
        onClick={onDelete}
        disabled={isDeleting}
        className="bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white text-sm px-3 py-1.5"
      >
        {isDeleting ? '刪除中...' : '🗑️ 刪除'}
      </Button>
    </div>
  );
};

export default MultiBulkActionButton;
